// StyledComponents.js
import { styled } from '@mui/system';
import { Box, Select, Table, TableContainer, Tabs } from '@mui/material';

export const Container = styled('div')({
  padding: '20px',
  backgroundColor: '#f4f6f8',
  minHeight: '100vh',
  boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
  borderRadius: '8px'
});

export const TabsWrapper = styled('div')({
  overflowX: 'auto',
  whiteSpace: 'nowrap',
  marginBottom: '20px'
});

export const StyledTabs = styled(Tabs)({
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 'bold',
    color: '#333',
    minWidth: 'auto',
    padding: '10px 20px',
    borderRadius: '8px 8px 0 0'
  },
  '& .MuiTab-root.Mui-selected': {
    color: '#ffffff',
    backgroundColor: '#2596be',
    borderBottom: 'none'
  },
  '& .MuiTabs-indicator': {
    backgroundColor: '#2596be',
    height: '4px',
    borderRadius: '4px'
  }
});

export const DropdownWrapper = styled(Box)({
  marginTop: '10px',
  marginBottom: '20px',
  display: 'flex',
  flexWrap: 'wrap',
  gap: '16px'
});

export const Dropdown = styled(Select)({
  minWidth: 150,
  backgroundColor: '#ffffff',
  borderRadius: '4px',
  border: '1px solid #dcdcdc',
  '& .MuiSelect-select': {
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px'
  },
  '& .MuiInputLabel-root': {
    fontSize: '14px'
  },
  '& .MuiMenuItem-root': {
    fontSize: '14px',
    padding: '8px 16px'
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '4px',
    '& fieldset': {
      borderColor: '#dcdcdc'
    },
    '&:hover fieldset': {
      borderColor: '#3f51b5'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#3f51b5'
    }
  }
});

export const ChartContainer = styled(Box)({
  marginBottom: '20px',
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  padding: '20px',
  boxShadow: '0px 4px 6px rgba(0,0,0,0.1)'
});

export const TableWrapper = styled(TableContainer)({
  maxHeight: '250px',
  overflowY: 'auto'
});

export const StyledTable = styled(Table)({
  '& .MuiTableHead-root': {},
  '& .MuiTableCell-head': {
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#ffffff',
    padding: '12px',
    backgroundColor: '#2596be'
  },
  '& .MuiTableCell-body': {
    textAlign: 'center',
    padding: '12px',
    borderBottom: '1px solid #e0e0e0'
  },
  '& .MuiTableRow-root:hover': {
    backgroundColor: '#f5f5f5'
  },
  '& .MuiTableRow-root:nth-of-type(odd)': {
    backgroundColor: '#fafafa'
  },
  '& .MuiTableCell-body:last-child': {
    fontWeight: 'bold',
    color: '#3f51b5'
  }
});
